import React, { useState, useEffect } from "react";
import "./Banners.css";
import { Link } from "react-router-dom";
import { MdArrowForwardIos } from "react-icons/md";
import { MdPlayCircleFilled } from "react-icons/md";
import Axios from "axios";
import { useAuth } from "../../AuthContext";
import { useBaseUrl } from "../../ApiContext";

export default function Banners() {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const [landingBg, setLandingBg] = useState("");

  useEffect(() => {
    const fetchLandingBg = async () => {
      try {
        const response = await Axios.get(`${baseUrl}/home_banner`, {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        });
        const data = response.data;
        if (data) {
          setLandingBg(data.cover);
        }
      } catch (error) {
        console.error("Error fetching image URL:", error);
      }
    };
    fetchLandingBg();
  }, [baseUrl, userToken]);

  return (
    <div className="banners enteredFlex">
      <a
        href="https://www.instagram.com/redroseworkout.ir?igsh=YzVkODRmOTdmMw=="
        className="banner instaBanner link"
      >
        <span>صفحه اینستاگرام من</span>
      </a>
      <Link to="/sportClasses" className="banner singUpBanner link">
        <MdArrowForwardIos className="bannerArrow" />
        <span>ثبت نام کلاس های ورزشی</span>
        <img src="/images/paper.svg" alt="paper" />
      </Link>
      <Link to="/offlineClasses" className="banner offlineClassesBanner link">
        <MdArrowForwardIos className="bannerArrow" />
        <span>کلاس های آفلاین</span>
        <img src="/images/bookmark.png" alt="bookmark" />
      </Link>
      <Link to="/shop" className="banner shopBanner link">
        <p className="shopBannerInner">REDROSE Shop</p>
        <div className="shopBannerContent centeredFlex">
          <img src="/images/nikeAirMax.png" alt="shoes" />
          <MdArrowForwardIos />
        </div>
      </Link>
      <Link to="/video" className="banner guideBanner link">
        <div className="guideBannerBgWrapper centeredFlex">
          <MdArrowForwardIos className="bannerArrow" />
          <div className="guideBannerInner">
            <div className="guideBannerContent centeredFlex">
              <p>راهنمای آموزش اپلیکیشن</p>
              <button className="centeredFlex">
                تماشا کنید
                <MdPlayCircleFilled className="playIcon" />
              </button>
            </div>
          </div>
        </div>
      </Link>
      <a
        href="https://www.redroseworkout.ir"
        className="banner landingPageBanner link"
        style={{ backgroundImage: `url(${landingBg})` }}
      >
        <MdArrowForwardIos className="bannerArrow whiteArrow" />
        RedRose Workout
      </a>
    </div>
  );
}
